import Store from '@data/Store';
const { language } = Store;

export const sheetColumnsReport = [
   { label: language.NUMBER, value: 'realid' },
   { label: language.REQUESTER, value: 'name_person' },
   { label: language.STATUS, value: 'status' },
   { label: language.DEPARTMENT, value: 'name_depart' },
   { label: language.DESCRIPTION, value: 'description' },
   { label: language.DATE_REGISTER, value: 'datarequest' },
   { label: language.HOUR_REGISTER, value: 'horarequest' },
   { label: language.CATEGORIZATION_DATE, value: 'dataticket' },
   { label: language.CATEGORIZATION_HOUR, value: 'horaticket' },
   { label: language.CLOSING_DATE, value: 'datafinal' },
   { label: language.CLOSING_HOUR, value: 'horafinal' },
   { label: 'SLA', value: 'sla' },
   { label: language.TECH_GROUP, value: 'group_tech' },
   { label: language.CATEGORY, value: 'nivel1' },
   { label: language.SUB_CATEGORY, value: 'nivel2' },
   { label: language.THIRD_LEVEL_CATEGORY, value: 'nivel3' },
   { label: language.TECHNICIAN_WHO_CATEGORIZED, value: 'tech_categorize' },
   { label: language.TIME_SPENT, value: 'time' },
   { label: language.AGREED_SLA, value: 'sla_task' },
   { label: language.ANALYST_WHO_CLOSED, value: 'tech_start' },
   { label: language.SUBJECT, value: 'subject' },
   { label: language.TYPE, value: 'name_status_tickets' },
   { label: language.COMPANY, value: 'name_company' },
   { label: language.CONTRACT, value: 'name_con' },
   { label: language.DEVICE, value: 'device_name' },
   { label: language.PRIORITY, value: 'priority' },
   { label: language.IMPACT, value: 'impact' },
   { label: language.URGENCY, value: 'urgency' },
   { label: language.COMPLEXITY, value: 'complexity' },
   { label: language.TECH_STATUS, value: 'statussta' },
   { label: language.EXPERIENCE, value: 'experience' },
   { label: language.RATING_LEVEL, value: 'avaliation_level' },
   { label: language.RESOLVED, value: 'resolved' },
   { label: language.SUGGESTIONS, value: 'suggestions' },
   { label: language.TICKET_CATEGORIZATION_TIME, value: 'vltime' },
   { label: language.TOTAL_TIME, value: 'id' },
   { label: language.REOPENED, value: 'reopened' },
   { label: language.SUPPLIER, value: 'name_company_provider' },
   { label: language.CALLED, value: 'ticket_for' },
   { label: language.MANAGER, value: 'name_sponsor' },
   { label: language.HISTORIC, value: 'notes' },
   { label: language.COMMENT, value: 'observation' },
   { label: language.FORMS, value: 'forms' }
 ];
 